import { CSSProperties, JSX } from "react";

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
  id?: string;
  style?: CSSProperties;
  role?: string;
  ariaLabelledBy?: string;
  ref?: React.Ref<HTMLDivElement>;
}

export const Section = (props: SectionProps): JSX.Element => {
  const { children, ...rest } = props;
  return <section {...rest}>{children}</section>;
};

/**
 * A flexible Section component that wraps content in a section element.
 * Extends all standard HTML section attributes and provides additional props
 * for accessibility and styling. Acts as a foundational layout component
 * that can be customized through props while maintaining semantic HTML structure.
 *
 * @component
 * @example
 * // Basic usage
 * <Section className="my-section">
 *   <p>Content goes here</p>
 * </Section>
 *
 * @example
 * // With accessibility props
 * <Section
 *   role="main"
 *   ariaLabelledBy="header-id"
 *   className="main-content"
 * >
 *   <h1 id="header-id">Page Title</h1>
 *   <p>Page content</p>
 * </Section>
 **/
